import { db } from '../config/firebase';
import {
    collection,
    addDoc,
    updateDoc,
    deleteDoc,
    doc,
    getDoc,
    getDocs,
    query,
    orderBy
} from 'firebase/firestore';
import { ProcessingMethod } from '../types/processingMethod';

const COLLECTION_NAME = 'processingMethods';

export const processingMethodService = {
    async getAllProcessingMethods() {
        try {
            const querySnapshot = await getDocs(
                query(
                    collection(db, COLLECTION_NAME),
                    orderBy('createdAt', 'desc')
                )
            );
            return querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            })) as ProcessingMethod[];
        } catch (error) {
            throw new Error('Không thể lấy danh sách phương pháp sơ chế: ' + error);
        }
    },

    async addProcessingMethod(processingMethod: ProcessingMethod) {
        try {
            const docRef = await addDoc(collection(db, COLLECTION_NAME), {
                ...processingMethod,
                createdAt: new Date(),
                updatedAt: new Date()
            });
            return { id: docRef.id, ...processingMethod };
        } catch (error) {
            throw new Error('Không thể thêm phương pháp sơ chế: ' + error);
        }
    },

    async updateProcessingMethod(id: string, processingMethod: Partial<ProcessingMethod>) {
        try {
            const docRef = doc(db, COLLECTION_NAME, id);
            await updateDoc(docRef, {
                ...processingMethod,
                updatedAt: new Date()
            });
            return { id, ...processingMethod };
        } catch (error) {
            throw new Error('Không thể cập nhật phương pháp sơ chế: ' + error);
        }
    },

    async deleteProcessingMethod(id: string) {
        try {
            await deleteDoc(doc(db, COLLECTION_NAME, id));
        } catch (error) {
            throw new Error('Không thể xóa phương pháp sơ chế: ' + error);
        }
    }
}; 